import { createContext } from 'react'
import getConfig from 'next/config'

import type { ParsedUrlQuery } from 'querystring'
import type { ChromeFlags } from '@/api/fe-common/getChromeFlags'

/**
 * `?brand-refresh-2026=on` forces the new chrome without fe-common's decision (same param as
 * fe-devices), for QA, Cypress and local work, where SERVER_FE_COMMON_URL is unset. Only honoured
 * while the gate is on.
 */
export const BRAND_REFRESH_OVERRIDE_PARAM = 'brand-refresh-2026'

export const BrandRefreshContext = createContext(false)

/**
 * Whether this visitor gets the template's own server-rendered design system header and footer.
 * fe-common owns the decision (getChromeFlags), so this follows whoever fe-common puts in the brand
 * refresh. ENABLE_BRAND_REFRESH_GATE is each MFE's opt in; without it fe-common's federated header
 * and footer render every variant, as before.
 */
export function resolveBrandRefresh(query: ParsedUrlQuery, chromeFlags?: ChromeFlags): boolean {
  const { publicRuntimeConfig } = getConfig()

  if (publicRuntimeConfig?.ENABLE_BRAND_REFRESH_GATE !== 'true') return false

  return chromeFlags?.isBrandRefresh === true || query[BRAND_REFRESH_OVERRIDE_PARAM] === 'on'
}
